import { AiFillCloseCircle } from "react-icons/ai";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";
import AdminService from "../../../services/admin.service";
import Modal from "../../common/Modal";
import GeneralInput from "../../common/GeneralInput";
import Select from "../../common/Select";
import { CashCategory } from "../../../types/common.types";

export default function EditPendingPayment() {
    const { setIsLoading } = useGlobal()
    const { editPendingPaymentData, setEditPendingPaymentData } = useAdmin()
    const [categories, setCategories] = useState<CashCategory[]>([])
    const [categoryId, setCategoryId] = useState(editPendingPaymentData?.category_id || '')
    const [counterpartName, setCounterpartName] = useState(editPendingPaymentData?.counterpart_name || '')
    const [totalAmount, setTotalAmount] = useState(String(editPendingPaymentData?.total_amount ?? ''))
    const [notes, setNotes] = useState(editPendingPaymentData?.notes || '')

    useEffect(() => {
        AdminService.listCashCategories('egreso').then(res => setCategories(res.data)).catch(console.log)
    }, [])

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.editCashPendingPayment(editPendingPaymentData!.id!, {
                category_id: categoryId,
                counterpart_name: counterpartName,
                total_amount: Number(totalAmount),
                notes: notes || undefined,
            })
            window.location.reload()
        } catch (error: any) {
            alert(error?.response?.data || 'No se pudo editar el pago pendiente')
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Editar pago pendiente</h1>
            <div className="input-container" style={{ marginTop: '15px' }}>
                <Select
                    label="Categoría"
                    required
                    defaultNull
                    value={categoryId}
                    options={categories.map(c => ({ value: c.id, name: c.name }))}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => setCategoryId(e.target.value)}
                />
                <GeneralInput
                    label="Contraparte"
                    required
                    value={counterpartName}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCounterpartName(e.target.value)}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                    label="Total a pagar"
                    type="number"
                    required
                    value={totalAmount}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setTotalAmount(e.target.value)}
                />
                <GeneralInput
                    label="Notas (opcional)"
                    value={notes}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setNotes(e.target.value)}
                />
            </div>
            <div className="actions">
                <button>Guardar</button>
            </div>
            <div className="close" onClick={() => setEditPendingPaymentData(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}
